<template>
  <b-container fluid>

    <b-row class="mt-3" v-if="groups.length > 0">
      <b-col sm="1" v-for="group in groupsTop" :key="group.id" align="center">
        <b-container v-if="!group.hidden && group.elevators.length > 0">
          <b-row>
            <b-col>
              <div v-if="group.elevators">
                <b-link :to="{ name: 'group', params: {id: group.id}}">
                  <elevators-status-small 
                    :name="group.name"
                    :description="group.description"
                    :elevators="group.elevators">
                  </elevators-status-small>
                </b-link>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button variant="danger">
                STOP
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <my-map v-if="mapLoaded && groupsLoaded" :key="groupsKey" :groups="groups" :template="mapTemplate"></my-map>
      </b-col>
    </b-row>

    <b-row v-if="groups.length > 0">
      <b-col sm="1" v-for="group in groupsBottom" :key="group.id" align="center">
        <b-container v-if="!group.hidden && group.elevators.length > 0">
        <b-row>
          <b-col>
            <div v-if="group.elevators">
              <b-link :to="{ name: 'group', params: {id: group.id}}">
                <elevators-status-small 
                  :name="group.name"
                  :description="group.description"
                  :elevators="group.elevators">
                </elevators-status-small>
              </b-link>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-button variant="danger" class="mr-1">
              STOP
            </b-button>
          </b-col>
        </b-row>
        </b-container>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'

import formatter from './formatter.mixin.js';

import ElevatorsStatusSmall from './ElevatorsStatusSmall.vue'

import Map from './Map.vue'

import moment from 'moment'
import axios from 'axios';

export default {
  name: 'map-page',
  mixins: [formatter],
  props: ['settings'],
  components: {
    'elevators-status-small': ElevatorsStatusSmall,
    'my-map': Map,
  },
  data() {
    return {
      mapTemplate: '',
      mapLoaded: false,
      groups: [],
      groupsKey: 0,
      groupsLoaded: false,
      refreshTimer: undefined,
    }
  },
  computed: {
    ungroupedElevators: function() {
         return {
           "name": "Other",
           "elevators": this.elevators,
         };
    },
    groupsByID: function() {
      return this.groups.sort(function(a,b) {
			if (a.id < b.id) {
				return -1
			}
			if (a.id > b.id) {
				return 1
			}
			return 0
      
    });
    },
    groupsWithElevators: function() {
        return this.groupsByID.filter(g => g.elevators.length > 0 && !g.hidden);
    },
    groupsTop: function() {
        return this.groupsByID.slice(0, 12);
    },
    groupsBottom: function() {
        return this.groupsByID.slice(12);
    },
  },
  methods: {
    hlGroup(id) {
      return;
      var canvas = this.$svg.get('#canvas').size('100%','100%');
      var statusGroupID = '#group-' + id;
      var element = this.$svg.get(statusGroupID);
      element.attr('opacity', 1);
    },
    unhlGroup(id) {
      return;
      var canvas = this.$svg.get('#canvas').size('100%','100%');
      var statusGroupID = '#group-' + id;
      var element = this.$svg.get(statusGroupID);
      element.attr('opacity', 0.3);
    },
    getGroups() {
      api.getGroups(groups => {
        if(groups.data) {
          this.groups = groups.data;
          this.groupsLoaded = true;
          this.groupsKey++;
        } else {
          this.groups = [];
          this.groupsLoaded = false;
        }
      });
    },
    /*
    getElevators() {
      api.getElevators(elevators => {
        if(elevators.data) {
          this.elevators = elevators.data;
          this.elevatorsLoaded = true;
        } else {
          this.elevators = [];
          this.elevatorsLoaded = false;
        }
      });
    },
    */
    getMap() {
      var ep = axios.create({
        baseURL: "",
      })
      ep.get('/static/img/map.svg')
        .then(res => {
          this.mapTemplate = res.data;
          this.mapLoaded = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    startRefresh() {
      this.getGroups();
      //this.getElevators();

      if(this.settings.refresh) {
        this.refreshTimer = setInterval(this.refresh, parseInt(this.settings.refresh));
      } else {
        this.refreshTimer = setInterval(this.refresh, 30000);
      }
    },
    stopRefresh() {
      //clearInterval(this.elevatorsRefreshTimer)
      clearInterval(this.refreshTimer)
    },
  },
  created() {
    this.getMap();
    this.startRefresh();
  },
  beforeDestroy() {
    this.stopRefresh();
  },
}
</script>

<style>
a {
  color: inherit;
  text-decoration: inherit;
}

a:hover {
  color: inherit;
  text-decoration: inherit;
}
</style>



// WEBPACK FOOTER //
// src/MapPage.vue